export default __webpack_public_path__ + "static/media/greeting6.7b903ac6.png";